//coming soon
if (window.location.pathname === '/pages/coming-soon') {
    // Remove old active classes
    // $('.header__primary-nav-item .parlinkactive').removeClass('parlinkactive');
    //$('.header__primary-nav-item .page-is-active').removeClass('page-is-active');


}



// ==========================
// Modal Popup
// ==========================
document.addEventListener("DOMContentLoaded", () => {

    if (!document.querySelector(".compare-modal")) {
        return; // ❌ Exit if modal doesn't exist on page
    }

    function setupModal(buttonId, modalId) {
        const modal = document.getElementById(modalId);
        const btn = document.getElementById(buttonId);

        if (!modal || !btn) return;

        const closeBtn = modal.querySelector(".close");

        btn.addEventListener("click", () => {
            modal.classList.add("show");
        });

        if (closeBtn) {
            closeBtn.addEventListener("click", () => {
                modal.classList.remove("show");
            });
        }

        window.addEventListener("click", (event) => {
            if (event.target === modal) {
                modal.classList.remove("show");
            }
        });
    }

    setupModal("openCompare", "compareModal");
    setupModal("openPricing", "pricingModal");

    $(document).on("keydown", function (e) {
        if (e.key === "Escape") {
            $(".compare-modal").removeClass("show");
        }
    });

});


// ==========================
// Header Hide on Scroll (Optimized)
// ==========================
document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector(".shopify-section--header");
    if (!header) return;

    let lastScrollY = window.scrollY;
    let ticking = false;

    window.addEventListener("scroll", () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                const currentScrollY = window.scrollY;
                const viewportHeight = window.innerHeight / 2;

                if (currentScrollY > viewportHeight) {
                    if (currentScrollY > lastScrollY) {
                        const headersearch = document.querySelector(".header-search[open]");
                        header.classList.toggle("header--hidden", !headersearch);
                    } else {
                        header.classList.remove("header--hidden");
                    }
                } else {
                    header.classList.remove("header--hidden");
                }

                lastScrollY = currentScrollY;
                ticking = false;
            });

            ticking = true;
        }
    });

    // ==========================
    // Form Key Hash Handling (unchanged)
    // ==========================
    if (!window.location.href.includes("form_key")) {
        const hash = window.location.hash;
        if (hash) {
            const targetEl = document.querySelector(hash);
            if (targetEl) {
                const elm = targetEl.querySelector(".fieldset-nl-elm");
                const resp = targetEl.querySelector(".fieldset-nl-resp");

                if (elm) elm.style.display = "none";
                if (resp) resp.style.display = "block";
            }
        }
    }
});


// ==========================
// Button Text Wrapping
// ==========================
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".button, .btn-link-main .link").forEach(btn => {
        const text = btn.innerText.trim();
        if (!text) return;

        btn.innerHTML = "";
        const span = document.createElement("span");
        span.textContent = text;
        btn.appendChild(span);
    });
});


// ==========================
// Hero Slide
// ==========================
document.addEventListener("DOMContentLoaded", () => {

    // 👉 OPTION 2: Exit if hero slider does not exist on this page
    const heroSection = document.querySelector(".home-hero-sec");
    const slidesWrapper = document.querySelector(".slides");

    if (!heroSection || !slidesWrapper) return;

    const slides = document.querySelectorAll(".slides .hero-content");
    const steps = document.querySelectorAll(".step");
    const dots = document.querySelectorAll(".step-progress .dot");
    const progressLine = document.getElementById("progress-line");

    if (!slides.length || !progressLine) return;

    const total = slides.length;
    let index = 0;
    let timer;
    let isManual = false;

    // ---- INIT ----
    activateSlide(0);
    autoPlay();

    // ---- DOT CLICK ----
    dots.forEach((dot, i) => {
        dot.addEventListener("click", () => {
            clearTimeout(timer);
            isManual = true;
            index = i;
            activateSlide(index);
            autoPlay();
        });
    });

    function activateSlide(i) {
        slides.forEach((slide, s) =>
            slide.classList.toggle("active", s === i)
        );

        steps.forEach((step, s) =>
            step.classList.toggle("active", s === i)
        );

        updateHeroBackground(i);
        updateProgress(i);
    }

    function updateHeroBackground(i) {
        const slide = slides[i];
        if (!slide) return;

        const bg = slide.getAttribute("data-bg");
        if (!bg) return;

        heroSection.style.backgroundImage = `url(${bg})`;
    }

    function updateProgress(i) {
        if (!steps[i]) return;

        const dot = steps[i].querySelector(".dot");
        const container = document.querySelector(".steps");
        if (!dot || !container) return;

        // ---------- READ PHASE ----------
        const cRect = container.getBoundingClientRect();
        const dRect = dot.getBoundingClientRect();

        const percent =
            ((dRect.left - cRect.left + dRect.width / 2) / cRect.width) * 100;

        // ---------- WRITE PHASE ----------
        requestAnimationFrame(() => {
            progressLine.style.width = percent + "%";
        });
    }


    function autoPlay() {
        timer = setTimeout(() => {
            index = (index + 1) % total;
            activateSlide(index);

            if (!isManual && index === 0) resetProgress();

            isManual = false;
            autoPlay();
        }, 6000);
    }

    function resetProgress() {
        progressLine.style.transition = "none";
        progressLine.style.width = "10%";

        requestAnimationFrame(() => {
            progressLine.style.transition = "width 0.6s ease";
        });
    }

});



// ==========================
// Duo Slider (Before-After)
// ==========================
document.addEventListener("DOMContentLoaded", () => {

    // 👉 OPTION 2: Exit if duo slider does not exist on this page
    const duoSlider = document.querySelector(".duo-slider");
    if (!duoSlider) return;

    const slides = duoSlider.querySelectorAll(".slide");
    if (!slides.length) return;

    const prevBtn = duoSlider.querySelector(".prev");
    const nextBtn = duoSlider.querySelector(".next");
    if (!prevBtn || !nextBtn) return;

    const header = document.querySelector(".shopify-section--header");
    const headerHeight = header ? header.offsetHeight : 0;

    let currentIndex = 0;
    let firstitmeslide = false;

    function showSlide(index) {
        slides.forEach((slide, i) =>
            slide.classList.toggle("is-active", i === index)
        );

        currentIndex = index;

        if (firstitmeslide && window.innerWidth <= 768) {
            const activeSlide = duoSlider.querySelector(".slide.is-active");
            if (activeSlide) {

                // ---------- READ ----------
                const slideTop =
                    activeSlide.getBoundingClientRect().top + window.scrollY;

                // ---------- WRITE ----------
                requestAnimationFrame(() => {
                    window.scrollTo({
                        top: slideTop - headerHeight,
                        behavior: "smooth"
                    });
                });
            }
        }

        firstitmeslide = true;
    }


    nextBtn.addEventListener("click", () => {
        showSlide((currentIndex + 1) % slides.length);
    });

    prevBtn.addEventListener("click", () => {
        showSlide((currentIndex - 1 + slides.length) % slides.length);
    });

    // ---- INIT ----
    showSlide(currentIndex);

});


// ==========================
// Slick Sliders (jQuery)
// ==========================
$(document).ready(function () {
    if ($(".fluidity-slider").length) {

        $('.fluidity-slider').slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            speed: 300,

            infinite: true,
            touchThreshold: 100,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 1299,
                    settings: { slidesToScroll: 3, slidesToShow: 3 }
                },
                {
                    breakpoint: 1024,
                    settings: { slidesToScroll: 2, slidesToShow: 2 }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.5, slidesToScroll: 1,
                        infinite: false,
                    }
                }
            ]
        });
    }

    $(window).on("load", function () {
        if ($(".success-stories").length) {
            const $slider = $(".success-stories");

            $slider.show();
            // Desktop / Tablet settings
            $slider.slick({
                centerMode: true,
                centerPadding: "300px",
                slidesToShow: 1,
                arrows: false,
                dots: true,
                draggable: true,
                swipe: true,
                adaptiveHeight: false,
                autoplay: true,
                autoplaySpeed: 7000,
                pauseOnHover: false,
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: {
                            centerPadding: "150px",
                            draggable: true,
                            swipe: true,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            centerPadding: "40px",
                            draggable: true,
                            swipe: true,
                        }
                    }
                ]
            });

            // Before change → reset all videos
            $slider.on("beforeChange", function (event, slick) {
                resetVideos(slick);
            });

            // On slide click → go to that slide
            $slider.on("click", ".slick-slide:not(.slick-active)", function (e) {
                e.preventDefault();
                const index = $(this).data("slick-index");
                $slider.slick("slickGoTo", index);
            });

            function resetVideos(slick) {
                const $slides = slick ? $(slick.$slides) : $(".success-stories .slick-slide");

                $slides.each(function () {
                    const $video = $(this).find("video");
                    const $iframe = $(this).find("iframe");
                    const $btn = $(this).find(".play-btn");
                    const $info = $(this).find(".info-chip");

                    if ($iframe.length) {
                        const $videothumbnail = $(this).find(".success-video-thumbnail");

                        loadVimeo(() => {
                            const player = new Vimeo.Player($iframe[0]);

                            player.pause().then(function () {
                                $videothumbnail.show();
                            }).catch(function (error) {
                                console.error("Vimeo error:", error.name);
                            });
                        });
                    }


                    else if ($video.length) {
                        // Only reset if video has been played
                        if ($video[0].played && $video[0].played.length > 0) {
                            $video[0].pause();
                            $video[0].currentTime = 0;

                            // Remove controls
                            $video.removeAttr("controls");

                            $video[0].load();
                        }
                    }

                    $info.show();
                    // Show play button back
                    $btn.show();
                });

            }
            $slider.on('mousedown touchstart', function () {
                $(this).find('iframe').css('pointer-events', 'auto'); // enable iframe only on interaction
            });

            $slider.on('mouseleave touchend', function () {
                $(this).find('iframe').css('pointer-events', 'none'); // disable again
            });
            // Play button click
            $slider.on("click", ".play-btn", function (e) {
                e.preventDefault();
                const $slide = $(this).closest(".slick-slide");
                if ($slide.hasClass("slick-active")) {
                    const $info = $slide.find(".info-chip");
                    const $player = $(this).attr("data-player");
                    if ($player == "vimeo") {
                        var $iframe = $(this).siblings("iframe:eq(0)");

                        if ($iframe.length) {
                            const $videothumbnail = $slide.find(".success--video-thumbnail");

                            $videothumbnail.hide(); // hide play button
                            $info.hide(); // hide play button
                            $(this).hide(); // hide play button

                            // Load Vimeo Player API
                            var player = new Vimeo.Player($iframe[0]);



                            // Pause the slider FIRST so it can't advance and trigger a reset
                            $slider.slick("slickPause");


                            // Force sound ON right before playing


                            player.play().then(function () {
                                try { player.setMuted(false); player.setVolume(1); } catch (e) { }
                                console.log('Video is playing with sound');
                            }).catch(function (error) {
                                console.error('Error playing video:', error.name);
                            });


                            //         var src = $iframe.attr('src');
                            //         var newSrc = src.replace('controls=0', 'controls=1') + '&autoplay=1'; 

                            //         // reload iframe with autoplay
                            //         $iframe.attr('src', newSrc);


                        }

                    } else {
                        const $video = $slide.find("video")[0];

                        if ($video) {
                            $info.hide(); // hide play button
                            $(this).hide(); // hide play button
                            $slide.find("video").attr("controls", true); // show controls
                            $video.play();
                            // Pause slider autoplay while video is playing
                            $slider.slick("slickPause");

                        }
                    }
                }

            });


        }
    });

    if ($(".imageslider").length) {
        $(".imageslider").slick({
            slidesToShow: 1.5,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            arrows: false,
            centerMode: false,
            responsive: [
                { breakpoint: 900, settings: { slidesToShow: 1.2 } },
                { breakpoint: 600, settings: { slidesToShow: 1 } }
            ]
        });
    }

    if ($(".transformation-slider-cs").length) {
        $(".transformation-slider-cs").slick({
            slidesToShow: 2.2,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            arrows: false,
            responsive: [
                { breakpoint: 900, settings: { slidesToShow: 1.2 } },
                { breakpoint: 600, settings: { slidesToShow: 1.1 } }
            ]
        });
    }
});

// ==========================
// Product Page - Size Selector
// ==========================
document.addEventListener("DOMContentLoaded", () => {
    const selector = document.getElementById("sizeSelector");
    if (!selector) return;

    const trigger = selector.querySelector(".select-trigger");
    const radios = selector.querySelectorAll('input[type="radio"]');
    if (!trigger || !radios.length) return;

    // Toggle dropdown
    trigger.addEventListener("click", () => {
        selector.classList.toggle("active");
    });

    // Update text on change
    radios.forEach(radio => {
        radio.addEventListener("change", () => {
            trigger.textContent = radio.value;
            selector.classList.remove("active");
        });
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", (e) => {
        if (!selector.contains(e.target)) {
            selector.classList.remove("active");
        }
    });
});


// ==========================
// About Timeline Section
// ==========================
$('.at-slides').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    dots: true,
    arrows: false,
    adaptiveHeight: true,
    pauseOnHover: false,
});

// ==========================
// About Video Section
// ==========================
$(document).ready(function () {
    var $playPauseBtn = $('#aVPlayPauseBtn');
    if ($playPauseBtn.length) {


        $playPauseBtn.on('click', function () {
            var playerType = $(this).data('player'); // jQuery data() automatically reads data-player
            var $parent = $playPauseBtn.closest(".about-vid-sec-wrap");
            const $contentel = $(".av-overlay", $parent);

            if (playerType == "vimeo") {
                var $iframe = $("iframe", $parent);

                const $videothumbnail = $(".about--video-thumbnail", $parent);


                // Load Vimeo Player API
                var player = new Vimeo.Player($iframe[0]);
                if ($contentel.hasClass("hidden")) {
                    player.pause().then(function () {

                        $videothumbnail.show(); // hide play button
                        $contentel.removeClass('hidden');
                    }).catch(function (error) {
                        console.error('Error playing video:', error.name);
                    });
                } else {
                    player.play().then(function () {
                        try { player.setMuted(false); player.setVolume(1); } catch (e) { }

                        $videothumbnail.hide(); // hide play button
                        $contentel.addClass('hidden');
                    }).catch(function (error) {
                        console.error('Error playing video:', error.name);
                    });
                }



                // Listen for pause event
                player.on('pause', function () {
                    $contentel.removeClass('hidden');
                    $videothumbnail.show(); // show thumbnail/play button if needed
                });

                // Listen for ended event
                player.on('ended', function () {
                    $contentel.removeClass('hidden');
                    $videothumbnail.show(); // show thumbnail/play button
                });

            } else {
                var $video = $('#av-background-video');

                if ($video[0].paused || $video[0].ended) {
                    $video[0].play();
                    $contentel.addClass('hidden');
                } else {
                    $video[0].pause();
                    $contentel.removeClass('hidden');
                }
            }
        });
    }
});

$(".product-cart-bottom a.button").on("click", function (e) {
    e.preventDefault();

    const $targetBtn = $('form[action="/cart/add"] buy-buttons').first();
    if (!$targetBtn.length) return;

    // 
    const windowHeight = window.innerHeight;
    const rect = $targetBtn[0].getBoundingClientRect();
    const scrollTo =
        rect.top + window.scrollY - (windowHeight - 100 - rect.height);

    // 
    requestAnimationFrame(() => {
        window.scrollTo({
            top: scrollTo,
            behavior: "smooth"
        });
    });
});


// // ==========================
// // === Remove child products when main is removed ===
// // ==========================
// document.addEventListener('click', function(e) {
//   const removeLink = e.target.closest('line-item-quantity a[href*="quantity=0"]');
//   if (!removeLink) return;

//   const lineEl = removeLink.closest('line-item');
//   if (!lineEl) return;

//   e.preventDefault();

//   const mainTag = (lineEl.dataset.productTags || '').split('|').find(t => t.startsWith('main-'));
//   if (!mainTag) {
//     // Not a main product → fallback
//     removeLink.click(); // let Shopify handle
//     return;
//   }

//   const mainId = mainTag.replace('main-', '');
//   const updates = {};
//   const lineItems = document.querySelectorAll('line-item[data-line-key]');

//   lineItems.forEach(li => {
//     const tags = (li.dataset.productTags || '').split('|');
//     if (tags.includes(main-child-${mainId}) || tags.includes(main-${mainId})) {
//       updates[li.dataset.lineKey] = 0;
//     }
//   });

//   // Send update to Shopify
//   fetch('/cart/update.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ updates })
//   })
//     .then(res => res.json())
//     .then(data => {
//       // Trigger Shopify's cart drawer update if available
//       if (window.theme && theme.cart && typeof theme.cart.updateCart === 'function') {
//         theme.cart.updateCart();
//       } else {
//         location.reload(); // fallback
//       }
//     });
// });


$(document).on('click', '.tab__btn-frx-protocol', function () {
    var $this = $(this);
    var sectionName = $this.data('sectionname'); // get attr data-sectionname

    // Remove active from all and add to current
    $('.tab__btn-frx-protocol').removeClass('active-tab-cs');
    $this.addClass('active-tab-cs');

    // Hide all left-tab-cs & right-tab-cs
    $('.left-tab-cs, .right-tab-cs').hide();

    // Show only matching elements (class name from data-sectionname)
    $('.' + sectionName).show();
});



//Resorces popupscript
jQuery(document).ready(function ($) {
    // Open specific popup on link click
    $(document).on("click", ".popup_link_text", function (e) {
        e.preventDefault();
        e.stopPropagation(); // prevent document click

        var targetId = $(this).data("id"); // get data-id value

        // Hide all popups first
        $(".res-popup-modal").removeClass("active");

        // Show the matching popup
        $("#" + targetId).addClass("active");
    });

    // Close when clicking the "X" button inside popup
    $(document).on("click", ".res-popup-close-btn", function (e) {
        e.stopPropagation();
        $(this).closest(".res-popup-modal").removeClass("active");
    });

    // Close when clicking on overlay (outside popup content)
    $(document).on("click", ".res-popup-modal", function (e) {
        if ($(e.target).is(".res-popup-modal")) {
            $(this).removeClass("active");
        }
    });

    $(document).on("keydown", function (e) {
        if (e.key === "Escape") {
            $(".res-popup-modal").removeClass("active");
        }
    });
});



jQuery(document).ready(function ($) {
    $('.downloadlink').on('click', function (e) {
        e.preventDefault(); // Prevent default navigation

        const fileUrl = $(this).attr('href'); // Get href
        if (!fileUrl) return; // No URL, do nothing

        // Extract file name from URL
        const fileName = fileUrl.split('/').pop().split('?')[0];

        // Fetch the file and download
        fetch(fileUrl)
            .then(response => {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.blob();
            })
            .then(blob => {
                const blobUrl = URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = blobUrl;
                a.download = fileName;
                a.click();

                URL.revokeObjectURL(blobUrl); // Clean up
            })
            .catch(err => console.error('Download failed:', err));
    });
});


$(document).ready(function () {
    var $related_prd_container = $('.collection-list-product_page');
    if ($related_prd_container) {
        var $items = $related_prd_container.children('product-card');

        if ($items.length != 0) {

            // Keep the first element
            var $firstItem = $items.first();
            var $restItems = $items.not(':first');

            // Shuffle remaining items
            $restItems = $restItems.sort(function () {
                return 0.5 - Math.random();
            });

            // Combine first item + shuffled rest
            var $newItems = $firstItem.add($restItems);

            // Keep only first 3 items
            $related_prd_container.empty().append($newItems.slice(0, 3));
        }
    }
});


// Workout Collection Slider
document.addEventListener("DOMContentLoaded", function () {

    // 👉 OPTION 2: Exit if slick slider does not exist
    const slider = document.querySelector(".slick-movement");
    if (!slider) return;

    // Extra safety: ensure slick is loaded
    if (typeof $.fn.slick !== "function") return;

    $(".slick-movement").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        arrows: false,
        dots: false,
        infinite: true,
        speed: 400,
        autoplay: true,
        centerMode: false,
        adaptiveHeight: false,

        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

});

// Explore image slider
document.addEventListener("DOMContentLoaded", function () {

    // 👉 OPTION 2: Exit if slider does not exist
    const slider = document.querySelector(".explore-img-slide");
    if (!slider) return;

    // Extra safety: ensure jQuery & Slick are loaded
    if (typeof window.jQuery === "undefined" || typeof $.fn.slick !== "function") {
        return;
    }

    // Prevent double initialization (important for Shopify / AJAX reloads)
    if ($(slider).hasClass("slick-initialized")) return;

    $(".explore-img-slide").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        arrows: false,
        dots: false,
        infinite: true,
        speed: 300,
        autoplay: true,
        centerMode: false,
        adaptiveHeight: false,

        responsive: [
            {
                breakpoint: 1200,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 1 }
            }
        ]
    });

});



// Preview Video Popup
document.addEventListener("DOMContentLoaded", function () {

    // 👉 OPTION 2: Exit if video modal does not exist
    const modal = document.getElementById("videoModal");
    if (!modal) return;

    const video = modal.querySelector("#modalVideo");
    const source = video?.querySelector("source");
    const closeBtn = modal.querySelector(".video-modal-close");
    const overlay = modal.querySelector(".video-modal-overlay");

    if (!video || !source || !closeBtn || !overlay) return;

    const previewButtons = document.querySelectorAll(".preview-btn");
    if (!previewButtons.length) return;

    previewButtons.forEach(btn => {
        btn.addEventListener("click", function () {
            const videoUrl = this.dataset.video;
            if (!videoUrl) return;

            source.src = videoUrl;
            video.load();
            video.play();

            modal.classList.add("active");
            modal.setAttribute("aria-hidden", "false");
        });
    });

    function closeModal() {
        modal.classList.remove("active");
        modal.setAttribute("aria-hidden", "true");

        video.pause();
        video.currentTime = 0;
        source.src = "";
    }

    closeBtn.addEventListener("click", closeModal);
    overlay.addEventListener("click", closeModal);

});